import React from 'react';
import cx from 'classnames';
import { change } from 'redux-form'
import MaskedInput from 'react-maskedinput';

import { store } from 'index';
import s from '../Profile.scss';
import { normalizePhone } from './utils';

const handleMaskedInputChange = (input, e) => {
  // FIXME: BAD!
  store.dispatch(change('ProfileForm', input.name, normalizePhone(e.target.value)));
};

const Input = ({ className, label, input, required, id, disabled, mask, meta: { touched, error, submitFailed } }) => {
  const classes = cx(s.InputWrapper, className);

  return (
    <div className={classes}>
      <label htmlFor={id}>{label}{required ? (<span> *</span>) : null}</label>
      {mask ?
        <MaskedInput
          mask={mask}
          className={cx(s.Input, { [s.Touched]: !!input.value }, { [s.Error]: error })}
          id={id}
          disabled={disabled}
          {...input}
          onChange={(e) => handleMaskedInputChange(input, e)}
        />
        :
        <input
          className={cx(s.Input, { [s.Touched]: !!input.value }, { [s.Error]: error })}
          id={id}
          disabled={disabled}
          {...input}
        />}
      {touched && error && !disabled && submitFailed && <span className={cx(s.Message, s.Error)}>{error}</span>}
    </div>
  );
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileForm/Input.js